import {Pipe, PipeTransform} from '@angular/core';
import {IStripeMultiPaymentMethods} from '../../types/payment.type';
import {PaymentMethodDetailsWithAddressDto} from '../../../userway/sdk/UserWayApiClient';

@Pipe({
  name: 'transformCardName',
})
export class TransformCardNamePipe implements PipeTransform {
  transform(cardInfo: PaymentMethodDetailsWithAddressDto | IStripeMultiPaymentMethods): string {
    return cardInfo.alias ? cardInfo.alias : (cardInfo.card.firstName || '') + ' ' + (cardInfo.card.lastName || '');
  }
}
